var map = {
	"./images/147years.jpg": 61,
	"./images/25.jpg": 62,
	"./images/branden-grace.jpg": 63,
	"./images/british-open-card.jpg": 64,
	"./images/claret-jug2.jpg": 65,
	"./images/harry-vardon.jpg": 66,
	"./images/header-large.jpg": 67,
	"./images/header-small.jpg": 68,
	"./images/headshots_married.png": 69,
	"./images/henrik-stenson.jpg": 70,
	"./images/iceland.jpg": 71,
	"./images/pattern-balls.png": 72,
	"./images/pattern-clubs.png": 73,
	"./images/pattern-tartan.png": 74,
	"./images/woods.jpg": 75,
	"./images/young-tom-morris.jpg": 76
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;


//////////////////
// WEBPACK FOOTER
// ./src/media ^\.\/.*\.*
// module id = 81
// module chunks = 0